// src/encounter/services/use-save-education.ts
// Rail-scoped save hook for the Education card (PROD-1272). PUT /api/Patients/PatientEducation/{patientId}
// (upsert — Flutter patient_data_source_impl.dart:451) and invalidate ['patient-detail', patientId]
// (the rail render source, PROD-1270). Transport + cache only; body shape lives in
// lib/to-education-request.ts.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { put } from '@/shared/api/api-client';
import type { EducationRequest } from '@/encounter/lib/to-education-request';

export function useSaveEducation(patientId: string | undefined) {
  const qc = useQueryClient();
  return useMutation<string, Error, EducationRequest>({
    mutationFn: (req: EducationRequest) =>
      put<string>(`/api/Patients/PatientEducation/${req.patientId}`, req.body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['patient-detail', patientId] });
    },
  });
}
